if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
    }

    connectedCallback() {
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification =
        document.querySelector('cart-notification') ||
        document.querySelector('cart-drawer');

      if (cartNotification && this.openedBy) {
        cartNotification.setActiveElement(this.openedBy);
      }

      if (this.modalContent) {
        this.modalContent.innerHTML = '';
      }

      if (preventFocus) this.openedBy = null;

      super.hide();
    }

    show(opener) {
      if (!opener) return;

      this.openedBy = opener;

      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');

      const spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const productUrl = opener.getAttribute('data-product-url');
      if (!productUrl) return;

      fetch(productUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');

          this.productElement =
            responseHTML.querySelector('section[id^="MainProduct-"]');

          if (!this.productElement) return;

          if (!this.modalContent) {
            this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
            if (!this.modalContent) return;
          }

          this.preventDuplicatedIDs();
          this.removeDOMElements();

          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();

          super.show(opener);
        })
        .catch((error) => {
          console.error('Quick Add Error:', error);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      if (!element) return;

      element.innerHTML = html;

      element.querySelectorAll('script').forEach((oldScriptTag) => {
        const newScriptTag = document.createElement('script');

        Array.from(oldScriptTag.attributes).forEach((attribute) => {
          newScriptTag.setAttribute(attribute.name, attribute.value);
        });

        newScriptTag.appendChild(
          document.createTextNode(oldScriptTag.innerHTML)
        );

        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      if (!this.modalContent) return;

      const variantPicker =
        this.modalContent.querySelector('variant-radios, variant-selects');

      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      if (!this.productElement) return;

      const pickupAvailability =
        this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal =
        this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialogs =
        this.productElement.querySelectorAll('modal-dialog');
      modalDialogs.forEach((modal) => modal.remove());
    }

    preventDuplicatedIDs() {
      if (!this.productElement) return;

      const sectionId = this.productElement.dataset.section;
      if (!sectionId) return;

      this.productElement.innerHTML =
        this.productElement.innerHTML.replaceAll(
          sectionId,
          `quickadd-${sectionId}`
        );

      this.productElement
        .querySelectorAll('variant-selects, variant-radios, product-info')
        .forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
    }

    removeGalleryListSemantic() {
      if (!this.modalContent) return;

      const galleryList =
        this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');

      galleryList
        .querySelectorAll('[id^="Slide-"]')
        .forEach((li) => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      if (!this.modalContent) return;

      const product = this.modalContent.querySelector('.product');
      if (!product) return;

      const desktopColumns =
        product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages =
        product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes =
        '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach((img) =>
        img.setAttribute('sizes', mediaImageSizes)
      );
    }
  });
}